import styled from "styled-components";
import { tabletLarge } from "styles/breakpoints";

import { Image } from "./Image";

interface Styles {
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  zIndex?: string;
  displayOnTablet?: string;
}

export const ImageAbsolute = styled(Image)<Styles>`
  position: absolute;
  top: ${({ top }) => top || ""};
  right: ${({ right }) => right || ""};
  bottom: ${({ bottom }) => bottom || ""};
  left: ${({ left }) => left || ""};
  z-index: ${({ zIndex }) => zIndex || ""};

  @media ${tabletLarge} {
    display: ${({ displayOnTablet }) => displayOnTablet || "none"};
  }
`;
